import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { MouseEvent } from 'react'
import { store } from 'store/store'
import { formatCurrency } from 'util/currency'
import { emdash, space } from 'util/typo'
import css from './PricesButton.module.scss'

const renderPrice = (min: number | undefined, max: number | undefined) => {
  let result = ''
  if (min && !max) result = i18n('MinPrice') + space + formatCurrency(min, 'RUB')
  if (!min && max) result = i18n('MaxPrice') + space + formatCurrency(max, 'RUB')
  if (min && max) result = formatCurrency(min, '') + space + emdash + space + formatCurrency(max, 'RUB')
  return result
}

export const PricesButton = observer(() => {
  const item = store.item!
  const { min_price, max_price } = item.rec
  const empty = max_price.value == null && min_price.value == null

  const onClick = useLatestCallback(() => {
    item.step = 'price'
  })

  const onClickClear = useLatestCallback((event: MouseEvent) => {
    event.stopPropagation()
    store.item!.clearPrices()
  })

  return <Button className={clsx(empty && css.empty)} pad={[0, 8]} primary={!empty} action={onClick}>
    <Typo size={13} one upper>
      {empty ? i18n('Price') : renderPrice(min_price.value, max_price.value)}
    </Typo>
    {!empty && <Space className={css.icon} center onClick={onClickClear}>
      <Icon size={16} name="close" />
    </Space>}
  </Button>
})
